import {Component, Input, OnInit} from '@angular/core';
import {StatusNegociacao} from "../../../aplicacao/enum/status-negociacao.enum";

@Component({
  selector: 'app-chip-status-negociacao',
  templateUrl: './chip-status-negociacao.component.html',
  styleUrls: ['./chip-status-negociacao.component.scss']
})
export class ChipStatusNegociacaoComponent implements OnInit{
  statusNegociacao = StatusNegociacao;
  @Input() informacoes;
  ngOnInit() {
  }
  tipoStatus(): string {
    switch (this.informacoes) {
      case this.statusNegociacao.GerandoOferta:
        return 'bg-warning';
      case this.statusNegociacao.AceiteContraOferta:
        return 'bg-success text-white';
      case this.statusNegociacao.NovaOfertaPjus:
        return 'bg-success text-white';
      case this.statusNegociacao.RecusaContraOferta:
        return 'bg-danger text-white';
      default:
        return 'bg-info text-white';
    }
  }

  corTexto(): string {
    if(this.informacoes === this.statusNegociacao.GerandoOferta) {
      return;
    } else {
      return 'text-white';
    }
  }

  tipoTexto(): string {
    switch (this.informacoes) {
      case this.statusNegociacao.GerandoOferta:
        return 'Em Análise';
      case this.statusNegociacao.AceiteContraOferta:
        return 'Aprovado';
      case this.statusNegociacao.NovaOfertaPjus:
        return 'Contraproposta PJUS';
      case this.statusNegociacao.RecusaContraOferta:
        return 'Reprovado';
      default:
        return '-';
    }
  }
}
